"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ContentFrameData2 = _interopRequireDefault(require("./ContentFrameData"));

var _creative = require("../../constants/creative");

var _isNotNil = _interopRequireDefault(require("../../utils/object/isNotNil"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ShapeFrameData = /*#__PURE__*/function (_ContentFrameData) {
  (0, _inherits2["default"])(ShapeFrameData, _ContentFrameData);

  var _super = _createSuper(ShapeFrameData);

  function ShapeFrameData(shape, fillColor) {
    var _this;

    (0, _classCallCheck2["default"])(this, ShapeFrameData);
    _this = _super.call(this, 400, 400);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_shape", _creative.SHAPE.SQUARE);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fillColor", _creative.DEFAULT_FILL_COLOR);

    if ((0, _isNotNil["default"])(shape)) {
      _this._shape = shape;
    }

    if ((0, _isNotNil["default"])(fillColor)) {
      _this._fillColor = fillColor;
    }

    return _this;
  }

  (0, _createClass2["default"])(ShapeFrameData, [{
    key: "equals",
    value: function equals(shapeFrameData) {
      if (!ShapeFrameData.isShapeFrameData(shapeFrameData)) return false;
      if (this === shapeFrameData) return true;
      return (0, _get2["default"])((0, _getPrototypeOf2["default"])(ShapeFrameData.prototype), "equals", this).call(this, shapeFrameData) && this.shape === shapeFrameData.shape && this.fillColor === shapeFrameData.fillColor;
    }
  }, {
    key: "shape",
    get: function get() {
      return this._shape;
    }
  }, {
    key: "fillColor",
    get: function get() {
      return this._fillColor;
    }
  }], [{
    key: "isShapeFrameData",
    value: function isShapeFrameData(shapeFrameData) {
      return shapeFrameData instanceof ShapeFrameData;
    }
  }]);
  return ShapeFrameData;
}(_ContentFrameData2["default"]);

exports["default"] = ShapeFrameData;